import {useRouteMatch} from "react-router";
import {PATHS} from "../../../route-dictionary";

const useCheckIdParams = () => {
  const matchObj = useRouteMatch(PATHS.CHECKS.DETAILS);
  const isChecksRulePage = !!matchObj;
  const checkId = isChecksRulePage ? matchObj.params.id : null;

  return {isChecksRulePage, checkId};
};

export default useCheckIdParams;